/**
 * A card on a website page that edits one thing — Wave 14E (C13, spec §10.5
 * item 2; the design bar of waves.md "### Wave 14").
 *
 * Navigation's card, with an icon: the heading and one muted line **inside**
 * the card body rather than in a bordered header strip, which is the Settings
 * pages' look (`SettingsSection`). The pages Wave 14 moved under *Your website*
 * — Client sign-in, Domain, Social profiles & map — wear this so they look like
 * the rest of the builder and not like the Settings pages they came from.
 */

import { Card, CardBody } from '@fiveox/ui'
import type { ReactNode } from 'react'

export function SiteSection({
  id,
  icon,
  title,
  description,
  aside,
  children,
}: {
  id?: string
  icon?: ReactNode
  title: string
  description?: ReactNode
  /** At the heading's right: a counter, a badge. */
  aside?: ReactNode
  children: ReactNode
}) {
  return (
    <section id={id} aria-labelledby={id ? `${id}-title` : undefined} className="scroll-mt-24">
      <Card>
        <CardBody className="space-y-4 p-4 sm:p-6">
          <div className="flex items-start gap-3">
            {icon && (
              <span className="bg-primary/10 text-primary flex h-9 w-9 shrink-0 items-center justify-center rounded-lg">
                {icon}
              </span>
            )}
            <div className="min-w-0 flex-1">
              <h2 id={id ? `${id}-title` : undefined} className="text-foreground text-base font-semibold">
                {title}
              </h2>
              {description && <div className="text-muted-foreground text-sm">{description}</div>}
            </div>
            {aside}
          </div>
          {children}
        </CardBody>
      </Card>
    </section>
  )
}
